export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'c3d44a2', dateTime: 1765405152452 };